<template>
  <form @submit.prevent="login">
    <div class="login-form">
      <h3>Sign In to Manage Your Account</h3>
      <h3 v-if="showError" style="color: red;">Email or Password Incorrect.</h3>
      <div class="form-group">
        <input type="text" v-model="email" placeholder="Email">
      </div>

      <div class="form-group">
        <input type="password" v-model="password" placeholder="Password">
      </div>

      <button type="submit" class="btn btn-primary">Login</button>
    </div>
  </form>
</template>

<script>

import {auth} from "@/firebaseConfig";

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      showError: false
    }
  },

  metaInfo: {
    title: 'Login to Your Account',
  },

  methods: {
    login: function() {
      let self = this;

      auth.signInWithEmailAndPassword(this.email, this.password)
      .then(function () {
        auth.currentUser.getIdTokenResult()
          .then(function(tokenResult) {
            if (
                (tokenResult.claims && tokenResult.claims.role === 'su') ||
                (tokenResult.claims && tokenResult.claims.agency && tokenResult.claims.agency === window.TravelPlatform.key)) {
              self.$router.replace(`bookings`);
              self.$store.dispatch('setCurrentUser', tokenResult);
            }
            else {
              self.$store.dispatch('setCurrentUser', null);
              auth.signOut().then(function () {
                  self.showError = true;
                  self.$set(self, 'showError', true);
                })
                .catch(err => {
                  console.log(err);
                });
            }
        })
        .catch(err => {
          console.log(err);
        });
      })
      .catch(err => {
        alert('Oops. ' + err.message)
      });

    }
  }
}
</script>